import { Amplify } from 'aws-amplify'
import { config } from '@/config'

let configured = false

function cognitoDomainHost(): string {
  const raw = config.cognito.domain.trim()
  return raw.replace(/^https?:\/\//, '').replace(/\/$/, '')
}

export function isCognitoConfigured(): boolean {
  return Boolean(
    config.cognito.userPoolId &&
      config.cognito.clientId &&
      config.cognito.domain,
  )
}

/** Configure Amplify Auth once (OAuth PKCE / Hosted UI). */
export function configureAmplify(): void {
  if (configured || !isCognitoConfigured()) {
    return
  }

  Amplify.configure({
    Auth: {
      Cognito: {
        userPoolId: config.cognito.userPoolId,
        userPoolClientId: config.cognito.clientId,
        loginWith: {
          oauth: {
            domain: cognitoDomainHost(),
            scopes: ['email', 'openid', 'profile'],
            redirectSignIn: [config.cognito.redirectSignIn],
            redirectSignOut: [config.cognito.redirectSignOut],
            responseType: 'code',
          },
        },
      },
    },
  })

  configured = true
}
